import Step from '@/step';

export default class StepThankYou extends Step {
    constructor(stepNumber) {
        super(stepNumber);
    }
}